import { map } from 'lodash';

import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';

import AppDispatcher from '../dispatcher/AppDispatcher';
import RemixerConstants from '../constants/RemixerConstants';

const VimeoSearchResult = Immutable.Record({
	title: undefined,
	video_id: undefined,
	url: undefined
});

class VimeoSearchResultStore extends ReduceStore<Immutable.List> {
	getInitialState(): Immutable.List {
		return new Immutable.List();
	}

	reduce(state: Immutable.List, action: Object): Immutable.List {
		switch (action.actionType) {
			case RemixerConstants.RECEIVE_SEARCH_VIMEO:
				return state.clear().push(...map(action.response.data.items, (entity) => new VimeoSearchResult(entity)));
			default: return state;
		}
	}
}

export default new VimeoSearchResultStore(AppDispatcher);
